/**
 * product-reviews.js
 * Shopify Dawn — Custom Review Systeem
 */

(function () {
  'use strict';

  // ─── Labels voor sterren ───────────────────────────────────────────────────
  const STAR_LABELS = ['', 'Slecht', 'Matig', 'Redelijk', 'Goed', 'Uitstekend'];

  // ─── Init wanneer DOM klaar is ─────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', () => {
    initStarRating();
    initCharCounter();
    initReviewForm();
  });

  // ─── Sterrenbeoordeling ────────────────────────────────────────────────────
  function initStarRating() {
    const container = document.getElementById('star-rating');
    const ratingInput = document.getElementById('rating-value');
    const starsLabel = document.getElementById('stars-label');

    if (!container) return;

    const buttons = container.querySelectorAll('.star-btn');
    let currentRating = 0;

    function highlightStars(upTo) {
      buttons.forEach((btn, i) => {
        btn.classList.toggle('star-btn--active', i < upTo);
      });
      if (starsLabel) {
        starsLabel.textContent = upTo > 0 ? STAR_LABELS[upTo] : '';
      }
    }

    buttons.forEach((btn, index) => {
      const value = index + 1;

      btn.addEventListener('mouseenter', () => highlightStars(value));

      btn.addEventListener('mouseleave', () => highlightStars(currentRating));

      btn.addEventListener('click', () => {
        currentRating = value;
        ratingInput.value = value;
        highlightStars(value);
        btn.setAttribute('aria-pressed', 'true');
        // Zet andere knoppen terug
        buttons.forEach((b, i) => {
          if (i !== index) b.setAttribute('aria-pressed', 'false');
        });
      });

      // Toetsenbord toegankelijkheid
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          btn.click();
        }
      });
    });
  }

  // ─── Tekentoller voor textarea ─────────────────────────────────────────────
  function initCharCounter() {
    const textarea = document.getElementById('review-text');
    const counter = document.getElementById('char-count');

    if (!textarea || !counter) return;

    textarea.addEventListener('input', () => {
      counter.textContent = textarea.value.length;
    });
  }

  // ─── Formulier verzenden ───────────────────────────────────────────────────
  function initReviewForm() {
    const form = document.getElementById('review-form');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      await submitReview(form);
    });
  }

  async function submitReview(form) {
    const statusEl = document.getElementById('form-status');
    const submitBtn = form.querySelector('.review-submit-btn');
    const ratingInput = document.getElementById('rating-value');

    // Valideer sterrenselectie
    if (!ratingInput.value) {
      setStatus(statusEl, 'Selecteer eerst een sterrenbeoordeling.', 'error');
      return;
    }

    // Valideer tekst
    const textEl = document.getElementById('review-text');
    if (!textEl.value.trim() || textEl.value.trim().length < 10) {
      setStatus(statusEl, 'Schrijf minimaal 10 tekens.', 'error');
      return;
    }

    // Laadstatus
    submitBtn.disabled = true;
    submitBtn.textContent = 'Versturen...';
    setStatus(statusEl, '', '');

    // Haal API URL op uit data-attribuut van het formulier
    const apiUrl = form.dataset.apiUrl;
    if (!apiUrl) {
      setStatus(statusEl, 'API URL niet ingesteld. Controleer de sectie-instellingen.', 'error');
      submitBtn.disabled = false;
      submitBtn.textContent = 'Beoordeling plaatsen';
      return;
    }

    // Bouw payload
    const formData = new FormData(form);
    const payload = {};
    formData.forEach((value, key) => {
      payload[key] = value;
    });

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setStatus(statusEl, '✓ Bedankt voor je beoordeling! Deze wordt zichtbaar na goedkeuring.', 'success');
        form.reset();
        document.querySelectorAll('.star-btn').forEach(b => b.classList.remove('star-btn--active'));
        document.getElementById('rating-value').value = '';
        if (document.getElementById('char-count')) {
          document.getElementById('char-count').textContent = '0';
        }
        if (document.getElementById('stars-label')) {
          document.getElementById('stars-label').textContent = '';
        }
        submitBtn.disabled = true;
        submitBtn.textContent = 'Beoordeling geplaatst';
      } else {
        const errorMsg = data.error || 'Er is iets misgegaan. Probeer het opnieuw.';
        setStatus(statusEl, errorMsg, 'error');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Beoordeling plaatsen';
      }
    } catch (err) {
      console.error('Review submit error:', err);
      setStatus(statusEl, 'Verbindingsfout. Controleer je internetverbinding en probeer opnieuw.', 'error');
      submitBtn.disabled = false;
      submitBtn.textContent = 'Beoordeling plaatsen';
    }
  }

  // ─── Helper: statustekst ───────────────────────────────────────────────────
  function setStatus(el, message, type) {
    if (!el) return;
    el.textContent = message;
    el.className = 'form-status';
    if (type) el.classList.add(`form-status--${type}`);
  }
})();
